import AlphabetIcon from './component'

export default AlphabetIcon
